export const LOAD_AMMOUNT = 3

export const SERVER_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_DEPLOYED_SERVER_URL
  : `${process.env.REACT_APP_SERVER_URL}:${process.env.REACT_APP_SERVER_PORT}`

export const POST_DETAIL_URL = `${SERVER_URL}/api/items/single/`
export const POST_DETAIL_URL_89 = `${SERVER_URL}/api/89items/single/`

export const MOBILE_BREAKPOINT = 768
export const PHOTOS_COL_COUNT = 3
export const PHOTOS_MAX_WIDTH = 1200
export const PHOTOS_GUTTER_WIDTH = 10



// WEBPACK FOOTER //
// ./src/constants.js